export default [
    { // 1

        title: 'Intro',
        header: ['Let&rsquo;s discover', 'your purple'],
        bullets: [
            { color: 'red', size: 75, blur: 20 },
            { color: 'blue', size: 45, blur: 10 }
        ],
        circles: null

    }, { // 2

        title: 'Purpose Driven',
        header: ['Purpose', 'Driven'],
        body: `From building innovative solutions, to helping colleagues excel, to making a real difference in your community - at Doane Grant Thornton you'll have the opportunity to make a lasting and meaningful impact.`,
        bullets: [
            { color: 'red', size: 60, blur: 0 },
            { color: 'blue', size: 35, blur: 10 }
        ],
        circles: null

    }, { // 3

        title: 'Discover a Place to Belong',
        header: ['Discover a place', 'to belong'],
        body: `Doane Grant Thornton thrives because our colleagues thrive. Here, you’ll experience a true sense of belonging through authentic human connection and trust.`,
        bullets: [
            { color: 'red', size: 35, blur: 10 },
            { color: 'blue', size: 30, blur: 5 }
        ],
        circles: null

    }, { // 4

        title: 'Discover Your Best Self',
        header: ['Discover', 'your best self'],
        body: 'Here, we encourage you to grow both professionally and personally, to live an amazing life fuelled by a rewarding career.',
        bullets: [
            { color: 'red', size: 50, blur: 0 },
            { color: 'red', size: 35, blur: 10 },
        ],
        circles: null

    }, { // 5

        title: 'Discover What Success',
        header: ['Discover', 'what success', 'feels like here'],
        body: `If you’re a bit like us, you’re driven by insatiable curiosity and the desire to get to the heart of what's personally important to people. You’re willing to step outside your comfort zone and inspire others to think in new ways.`,
        bullets: [
            { color: 'blue', size: 35, blur: 10 },
            { color: 'blue', size: 35, blur: 15 },
            { color: 'blue', size: 35, blur: 10 }
        ],
        circles: null

    }, { // 6

        title: 'Discover Your Purple',
        header: ['Discover your', 'purple'],
        body: 'Now that you know a little bit more about who we are, we want to know a little bit more about you.',
        bullets: [
            { color: 'blue', size: 50, blur: 10 },
            // { color: 'green', size: 35, blur: 5 },
            { color: 'red', size: 40, blur: 0 }
        ],
        circles: [
            {
                text: 'dir',
                media: 'Adrienne_Barriault',
                type: 'image',
                desktop: {
                    offset: 0, degree: 0
                },
                mobile: {
                    offset: 0, degree: 0
                }
            }, {
                text: 'dir',
                media: 'Connor_Aucoin',
                type: 'image',
                desktop: {
                    offset: 0, degree: 0
                },
                mobile: {
                    offset: 0, degree: 0
                }
            }, {
                text: 'dir',
                media: 'Tifany_Diaz',
                type: 'image',
                desktop: {
                    offset: 0, degree: 0
                },
                mobile: {
                    offset: 0, degree: 0
                }
            }, {
                text: 'dir',
                media: 'Umang_Parmar',
                type: 'image',
                desktop: {
                    offset: 0, degree: 0
                },
                mobile: {
                    offset: 0, degree: 0
                }
            }, {
                text: 'dir',
                media: 'Asianique_Clark',
                type: 'image',
                desktop: {
                    offset: 0, degree: 0
                },
                mobile: {
                    offset: 0, degree: 0
                }
            }
        ]

    }
] // slides //